import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "@brivity/ai-components/dist/style.css";
import { AiComponentsProvider, AskPlace, AskPlaceToggleButton } from "@brivity/ai-components";
import useAiToken from "@shared/AiAssistant/hooks/useAiToken";
import useMediaQuery from "@shared/v2/useMediaQuery";
import { useIsAdmin, useCurrentSuperUser } from "../../reducers/layoutReducer/selectors";

const AiAskPlace = () => {
  // If we need to make this component triggerable in more locations we'll need to move this to redux
  const [isAskPlaceOpen, setIsAskPlaceOpen] = useState(false);
  const { apiUrl, token } = useAiToken();
  const isSuperUser = useCurrentSuperUser();
  const isMetaUser = useSelector(({ layout }) => layout.currentMetaUser);
  const sidebar = useSelector(({ layout }) => layout.sidebar?.isOpen);
  const [leftOffset, setLeftOffset] = useState(60);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isShortScreen = useMediaQuery("(max-height: 767px)");
  const isAdmin = useIsAdmin();

  useEffect(() => {
    setLeftOffset(sidebar ? 260 : 60);
  }, [sidebar]);

  const topOffset = 52 + (isMetaUser ? 52 : 0) + (isSuperUser ? 52 : 0);

  // we don't want to cover the Intercom bubble on the shorter screens
  const defaultY = isShortScreen ? 0 : topOffset + 10;
  const person = useSelector((state) => state.personDetail.person);
  const isPersonUser = ["Agent", "Administrator", "Account Owner"].includes(person?.personType);
  const leadUuid = isPersonUser ? undefined : person.data?.attributes?.uuid;

  return (
    <AiComponentsProvider
      apiUrl={apiUrl}
      token={token}
      theme={document.body.classList.contains("place-theme") ? "ai-place" : "ai-brivity"}
    >
      <AskPlaceToggleButton
        onClick={() => setIsAskPlaceOpen((isOpen) => !isOpen)}
        isAskPlaceOpen={isAskPlaceOpen}
      />
      {!isMobile && isAskPlaceOpen && (
        <AskPlace
          isAdmin={isAdmin}
          defaultY={defaultY}
          leadUuid={leadUuid}
          maximized={{ offset: { top: topOffset, left: leftOffset } }}
          // the default position of the minimized version is bottom right
          // same as the Intercom bubble
          // we want to move it a bit to the left so it doesn't cover the Intercom bubble
          minimized={{ offset: { x: -68 } }}
          onMinimize={() => setIsAskPlaceOpen(false)}
        />
      )}
    </AiComponentsProvider>
  );
};

export default AiAskPlace;
